
@switch (slide?.type) {
  @case ('Title_slide') {
    <app-title-slide
      class="prismic-slide"
      [data]="slide"
      [training]="training"
      [nextLink]="nextLink"
      [backLink]="backLink">
    </app-title-slide>
  }
  @case ('Video_slide') {
    <app-prismic-video
      class="prismic-slide"
      [data]="slide"
      (trackProgress)="trackProgress()"
      [nextLink]="nextLink"
      [backLink]="backLink"
      [training]="training"
      [queryParams]="queryParams">
    </app-prismic-video>
  }
  @case ('Link_slide') {
    <app-prismic-link
      class="prismic-slide"
      [data]="slide"
      (trackProgress)="trackProgress()"
      [nextLink]="nextLink"
      [backLink]="backLink">
    </app-prismic-link>
  }
  @case ('Quiz_slide') {
    <app-prismic-quiz
      class="prismic-slide"
      [data]="slide"
      (trackProgress)="trackProgress()"
      [nextLink]="nextLink"
      [backLink]="backLink">
    </app-prismic-quiz>
  }
  @case ('Certificate_slide') {
    @if ((hideCertificate$ | async) === false) {
      <app-certificate-slide
        class="prismic-slide"
        [data]="slide"
        [training]="training"
        [currentProgress]="currentProgress"
        (trackProgress)="trackProgress()"
        [backLink]="backLink">
      </app-certificate-slide>
    } @else {
      <app-cmi5-termination-slide class="prismic-slide"> </app-cmi5-termination-slide>
    }
  }
  @case ('User_training_rating_slide') {
    <app-prismic-rating
      class="prismic-slide"
      [data]="slide"
      [training]="training"
      (trackProgress)="trackProgress()"
      [nextLink]="nextLink"
      [backLink]="backLink">
    </app-prismic-rating>
  }
  @case ('Interactive_content_slide') {
    <app-prismic-interactive-content
      class="prismic-slide"
      [data]="slide"
      (trackProgress)="trackProgress()"
      [nextLink]="nextLink"
      [backLink]="backLink">
    </app-prismic-interactive-content>
  }
  @case ('Passive_content_slide') {
    <app-prismic-link
      class="prismic-slide"
      [data]="slide"
      (trackProgress)="trackProgress()"
      [nextLink]="nextLink"
      [backLink]="backLink">
    </app-prismic-link>
  }
}
